module.exports = __webpack_public_path__ + "img/btn_google_dark_pressed_ios.a07308de.svg";